//
//
//
//
//
//
//
//

import Preloader from '@/components/common/Preloader'
import PartnerFooter from '@/components/common/footer/PartnerFooter'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Privacy',
  components: { Preloader, PartnerFooter },
  computed: {
    ...mapGetters({
      mainSettings: 'landings/mainSettings',
    }),
    ...mapState(['i18n']),
  },
  methods: {},
}
